function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var getStyles = function getStyles(prefixCls, token) {
  return _defineProperty({}, ".".concat(prefixCls), {
    paddingBottom: 16,
    '.title': {
      minWidth: '200px',
      fontSize: 18,
      color: '#0D1121',
      fontWeight: 600,
      margin: 0,
      marginBottom: 12
    },
    '.content': {
      display: 'flex',
      flexDirection: 'column',
      gap: 16
    },
    '.line': {
      display: 'flex',
      alignItems: 'center',
      gap: 40,
      '.item': {
        '.item-key': {
          fontSize: 13,
          color: '#6E707A',
          marginBottom: 5,
          minWidth: 80
        },
        '.item-value': {
          display: 'flex',
          alignItems: 'center',
          fontSize: 14,
          color: '#0D1121',
          gap: 4
        },
        '.person-list': {
          display: 'flex',
          alignItems: 'center',
          gap: 4,
          overflow: 'hidden',
          maxWidth: 300,
          color: '#336DFF',
          cursor: 'pointer'
        },
        '.person-text': {
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        },
        '.person-addon': {
          flexShrink: 0
        }
      },
      '.statusDot': {
        width: 6,
        height: 6,
        borderRadius: '100%',
        backgroundColor: '#b4b4b4'
      },
      '.textWarn': {
        color: '#f27a3b'
      },
      '.textDanger': {
        color: '#f5222d'
      }
    }
  });
};